export var SET_LOADING_STATUS = 'set loading status';
export var setLoadingStatus = function setLoadingStatus(status) {
  return {
    type: SET_LOADING_STATUS,
    payload: status
  };
};
var getTimeout = function getTimeout(key, state) {
  var _state$external$loadi;
  return (_state$external$loadi = state.external.loading) === null || _state$external$loadi === void 0 || (_state$external$loadi = _state$external$loadi[key]) === null || _state$external$loadi === void 0 ? void 0 : _state$external$loadi.timeout;
};
export var updateLoadingStatus = function updateLoadingStatus(_ref) {
  var key = _ref.key,
    loading = _ref.loading,
    progress = _ref.progress,
    time = _ref.time;
  return function (dispatch, getState) {
    var _state$loading;
    var state = getState();
    var keyIsLoading = (_state$loading = state.loading) === null || _state$loading === void 0 || (_state$loading = _state$loading[key]) === null || _state$loading === void 0 ? void 0 : _state$loading.loading;
    var timeoutForKey = getTimeout(key, state);
    if (!keyIsLoading && loading) {
      var timeout = window.setTimeout(function () {
        return dispatch(setLoadingStatus({
          key: key,
          loading: loading,
          progress: progress,
          time: time
        }));
      }, 400);
      dispatch(setLoadingStatus({
        key: key,
        timeout: timeout
      }));
    }
    if (timeoutForKey && !loading) {
      window.clearTimeout(timeoutForKey);
      dispatch(setLoadingStatus({
        key: key,
        loading: loading,
        progress: progress,
        time: time,
        timeout: null
      }));
    }
  };
};